import React, { useState } from "react";
import reset from "../assets/delete.svg";
import { Link } from "react-router-dom";
import "../App.css";

function SearchBar(props) {
  const [searchPokemon, setSearchPokemon] = useState("");

  const resetConter = () => {
    setSearchPokemon("");
  };

  return (
    <div>
      <div className="flex justify-center px-5 pb-2">
        {searchPokemon ? (
          <img
            src={reset}
            alt="close"
            className="invisible max-h-10 pl-1.5 pt-4"
          />
        ) : null}
        <input
          type="text"
          name="searchBar"
          id="searchBar"
          value={searchPokemon}
          className="block w-full sm:max-w-lg px-4 py-2 placeholder:text-black text-center bg-sky-200/50 border-2 border-blue-600 rounded-full  focus:ring-yellow-400 focus:outline-hidden focus:ring-3 focus:ring-opacity-40"
          placeholder="Recherche ton Pokemon"
          onChange={(e) => setSearchPokemon(e.target.value)}
        />
        {searchPokemon ? (
          <img
            src={reset}
            alt="close"
            onClick={resetConter}
            className="max-h-10 pl-1.5 pt-4 cursor-pointer"
          />
        ) : null}
      </div>

      <div className="select">
        <div className="absolute inset-x-0.5 overflow-x-hidden sm:max-h-36 max-h-48 max-w-xl px-8 mx-auto">
          <ul className="backdrop-blur-xs rounded-3xl text-center opacity-90">
            {props.allPokemon
              .filter((val) => {
                return val.name
                  .toLowerCase()
                  .includes(searchPokemon.toLowerCase());
              })
              .map((val) => {
                return (
                  <div className="searchresult" key={val.id}>
                    {searchPokemon ? (
                      <Link to={`/pokemon/${val.id}`}>
                        <li
                          className="hover:text-yellow-400 font-bold cursor-pointer hover:text-xl hover:py-2.5"
                          key={val.pokedexId}
                        >
                          {val.name}
                        </li>
                      </Link>
                    ) : null}
                  </div>
                );
              })}
          </ul>
        </div>
      </div>
    </div>
  );
}

export default SearchBar;
